import React from 'react';
import {
  IGetCounterItems,
  ICounterItems,
  flightTypesList,
  flightClassesList,
  getModalType,
} from './types';

export const listOfFlightTypes = {
  [flightTypesList.ROUND_TRIP]: {
    id: 'opt_roundTrip',
    translationKey: 'flightType.roundTrip',
    icon: <i className="smls-icon-round-trip" />,
    value: flightTypesList.ROUND_TRIP,
  },
  [flightTypesList.ONE_WAY]: {
    id: 'opt_oneWay',
    translationKey: 'flightType.oneWay',
    icon: <i className="material-icons departure-icon">flight</i>,
    value: flightTypesList.ONE_WAY,
  },
  [flightTypesList.MULTI_CITY]: {
    id: 'opt_destinations',
    translationKey: 'flightType.multiCity',
    icon: <i className="smls-icon-round-trip" />,
    value: flightTypesList.MULTI_CITY,
  },
};

export const listOfClassTypes = {
  [flightClassesList.ALL]: {
    id: 'opt_allClasses',
    translationKey: 'classType.allClasses',
    icon: <i className="material-icons">stars</i>,
    value: flightClassesList.ALL,
    description: '',
  },
  [flightClassesList.ECONOMIC]: {
    id: 'opt_economical',
    translationKey: 'classType.economy',
    icon: <i className="material-icons">stars</i>,
    value: flightClassesList.ECONOMIC,
    description: 'classType.economyOnlyText',
  },
  [flightClassesList.BUSINESS]: {
    id: 'opt_executive',
    translationKey: 'classType.business',
    icon: <i className="material-icons">stars</i>,
    value: flightClassesList.BUSINESS,
    description: '',
  },
};

export function getCounterItems({
  t,
  adultsValue,
  childrenValue,
  babiesValue,
}: IGetCounterItems): ICounterItems[] {
  return [
    {
      counterName: t('counter.adultPluralText'),
      name: t('counter.adultSingularText'),
      min: 1,
      defaultValue: adultsValue,
      counterNameId: 'lbl_msgInformativeAdultPerson',
      counterMinusId: 'btn_subtractAdultPerson',
      counterValueId: 'lbl_numberOfAdults',
      counterSumId: 'btn_addAdultPerson',
    } as ICounterItems,
    {
      counterName: t('counter.childrenPluralText'),
      name: t('counter.childrenSingularText'),
      description: '2 a 11 anos',
      min: 0,
      defaultValue: childrenValue,
      counterNameId: 'lbl_msgInformativeChildren_1',
      counterDescriptionId: 'lbl_msgInformativeChildren_2',
      counterMinusId: 'btn_subtractChildren',
      counterValueId: 'lbl_numberOfChildren',
      counterSumId: 'btn_addChildren',
    } as ICounterItems,
    {
      counterName: t('counter.babyPluralText'),
      name: t('counter.babySingularText'),
      description: t('counter.babyDescription'),
      maxCompareIndex: 0,
      min: 0,
      notIncludedTotalValue: true,
      warningMaxMessage: t('counter.babyMaxMessage'),
      defaultValue: babiesValue,
      counterNameId: 'lbl_msgInformativeBabies_1',
      counterDescriptionId: 'lbl_msgInformativeBabies_2',
      counterMinusId: 'btn_subtractBabies',
      counterValueId: 'lbl_numberOfBabies',
      counterSumId: 'btn_addBabies',
      warningMessageId: 'lbl_notificationsBabies',
    } as ICounterItems,
  ];
}

export const listOfModalTypes = {
  [getModalType.GENERAL_ERROR]: {
    closeBtnId: 'btn_closeSystemErrorFligthSearch',
    titleId: 'lbl_titleSystemErrorFligthSearch',
    descriptionId: 'lbl_msgInformativeSystemErrorFligthSearch_1',
    submitBtnId: 'btn_tryAgain',
  },
  [getModalType.SAME_DAY]: {
    closeBtnId: 'btn_closeTripForToday',
    titleId: 'lbl_titleTripForToday',
    descriptionId: 'lbl_msgInformativeTripForToday_1',
    submitBtnId: 'btn_letsGo',
  },
  [getModalType.INVALID_MULTICITY]: {
    closeBtnId: 'btn_closeSearchTravelFailed',
    titleId: 'lbl_titleSearchTravelFailed',
    descriptionId: 'lbl_msgInformativeSearchTravelFailed_1',
    submitBtnId: 'btn_oneWaySearch',
  },
  [getModalType.SAME_DAY_INTERNATIONAL]: {
    closeBtnId: 'btn_closeSameDayInternational',
    titleId: 'lbl_titleSameDayInternational',
    descriptionId: 'lbl_msgInformativeSameDayInternational_1',
    submitBtnId: 'btn_sameDayInternational',
  },
};
